(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dcu-saree-personalizer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dcu-saree-personalizer')) {
    customElements.define('dcu-saree-personalizer', class extends HTMLElement {
      connectedCallback() {
        this.formId = this.closest('.product-information__grid')?.querySelector('form.shopify-product-form[action*="/cart/add"]')?.getAttribute('id') || '';
        this.propertiesHost = this.querySelector('[data-form-properties]');
        this.error = this.querySelector('.dcu-personalizer__error');
        this.sleevesCheckbox = this.querySelector('[data-paid-service="sleeves"]');
        this.sleeveSelect = this.querySelector('[data-sleeve-length]');
        this.addEventListener('change', () => this.update());
        this.addEventListener('input', () => this.updateProperties());
        document.addEventListener('submit', event => {
          if (event.target.getAttribute('id') === this.formId && !this.submitting) this.handleSubmit(event);
        }, true);
        this.update();
      }

      selectedPaid() {
        return [...this.querySelectorAll('[data-paid-service]:checked')];
      }

      update() {
        if (this.sleeveSelect) this.sleeveSelect.disabled = !this.sleevesCheckbox.checked;
        const total = this.selectedPaid().reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
        this.querySelector('[data-upgrade-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency', currency:window.Shopify?.currency?.active || 'USD', maximumFractionDigits:0 }).format(total / 100);
        document.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = true; });
        this.updateProperties();
      }

      collectProperties() {
        const properties = {};
        this.querySelectorAll('[data-property]').forEach(input => {
          if (input.type === 'checkbox') properties[input.dataset.property] = input.checked ? 'Yes' : 'Removed by customer';
        });
        if (this.sleevesCheckbox?.checked) properties['Sleeve length'] = this.sleeveSelect.value;
        this.querySelectorAll('[data-detail]').forEach(input => {
          if (input.value.trim()) properties[input.dataset.detail] = input.value.trim();
        });
        return properties;
      }

      updateProperties() {
        if (!this.formId) return;
        const properties = this.collectProperties();
        this.propertiesHost.replaceChildren(...Object.entries(properties).map(([name,propertyValue]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${name}]`;
          input.setAttribute('value', String(propertyValue));
          input.setAttribute('form', this.formId);
          return input;
        }));
      }

      async handleSubmit(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.submitting = true;
        this.error.hidden = true;
        const form = event.target;
        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;
        const formData = new FormData(form);
        const mainVariant = Number(formData.get('id'));
        const quantity = Math.max(1, Number(formData.get('quantity') || 1));
        const properties = this.collectProperties();
        const variantMap = {
          prepleat:this.dataset.prepleatVariant,
          higherNeckline:this.dataset.higherNecklineVariant,
          coveredBack:this.dataset.coveredBackVariant,
          longerBlouse:this.dataset.longerBlouseVariant,
          sleeves:this.dataset.sleevesVariant,
          lining:this.dataset.liningVariant
        };
        const serviceItems = this.selectedPaid().map(input => ({
          id:Number(variantMap[input.dataset.paidService]),
          quantity,
          properties:{
            'For saree':this.dataset.productTitle,
            'Selected option':input.dataset.property,
            '_Source product':this.dataset.productHandle,
            '_Source variant':String(mainVariant),
            ...(input.dataset.paidService === 'sleeves' ? {'Sleeve length':this.sleeveSelect.value} : {})
          }
        }));
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method:'POST',
            headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({items:[{id:mainVariant,quantity,properties},...serviceItems]})
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(`${window.Shopify.routes.root}cart`);
        } catch (error) {
          this.error.hidden = false;
          this.submitting = false;
          if (submitButton) submitButton.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dcu-saree-prepleat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saree-personalizer')) {
    customElements.define('saree-personalizer', class extends HTMLElement {
      connectedCallback() {
        this.formId = this.closest('.product-information__grid')?.querySelector('form.shopify-product-form[action*="/cart/add"]')?.getAttribute('id') || '';
        this.propertiesHost = this.querySelector('[data-form-properties]');
        this.error = this.querySelector('.dcu-personalizer__error');
        this.sleevesCheckbox = this.querySelector('[data-paid-service="sleeves"]');
        this.sleeveSelect = this.querySelector('[data-sleeve-length]');
        this.addEventListener('change', () => this.update());
        this.addEventListener('input', () => this.updateProperties());
        document.addEventListener('submit', event => {
          if (event.target.getAttribute('id') === this.formId && !this.submitting) this.handleSubmit(event);
        }, true);
        this.update();
      }

      selectedPaid() {
        return [...this.querySelectorAll('[data-paid-service]:checked')];
      }

      update() {
        if (this.sleeveSelect) this.sleeveSelect.disabled = !this.sleevesCheckbox.checked;
        const total = this.selectedPaid().reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
        this.querySelector('[data-upgrade-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency', currency:window.Shopify?.currency?.active || 'USD', maximumFractionDigits:0 }).format(total / 100);
        document.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = true; });
        this.updateProperties();
      }

      collectProperties() {
        const properties = {};
        this.querySelectorAll('[data-property]').forEach(input => {
          if (input.type === 'checkbox') properties[input.dataset.property] = input.checked ? 'Yes' : 'Removed by customer';
        });
        if (this.sleevesCheckbox?.checked) properties['Sleeve length'] = this.sleeveSelect.value;
        this.querySelectorAll('[data-detail]').forEach(input => {
          if (input.value.trim()) properties[input.dataset.detail] = input.value.trim();
        });
        return properties;
      }

      updateProperties() {
        if (!this.formId) return;
        const properties = this.collectProperties();
        this.propertiesHost.replaceChildren(...Object.entries(properties).map(([name,propertyValue]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${name}]`;
          input.setAttribute('value', String(propertyValue));
          input.setAttribute('form', this.formId);
          return input;
        }));
      }

      async handleSubmit(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.submitting = true;
        this.error.hidden = true;
        const form = event.target;
        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton) submitButton.disabled = true;
        const formData = new FormData(form);
        const mainVariant = Number(formData.get('id'));
        const quantity = Math.max(1, Number(formData.get('quantity') || 1));
        const properties = this.collectProperties();
        const variantMap = {
          prepleat:this.dataset.prepleatVariant,
          higherNeckline:this.dataset.higherNecklineVariant,
          coveredBack:this.dataset.coveredBackVariant,
          longerBlouse:this.dataset.longerBlouseVariant,
          sleeves:this.dataset.sleevesVariant,
          lining:this.dataset.liningVariant
        };
        const serviceItems = this.selectedPaid().map(input => ({
          id:Number(variantMap[input.dataset.paidService]),
          quantity,
          properties:{
            'For saree':this.dataset.productTitle,
            'Selected option':input.dataset.property,
            '_Source product':this.dataset.productHandle,
            '_Source variant':String(mainVariant),
            ...(input.dataset.paidService === 'sleeves' ? {'Sleeve length':this.sleeveSelect.value} : {})
          }
        }));
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method:'POST',
            headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({items:[{id:mainVariant,quantity,properties},...serviceItems]})
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(`${window.Shopify.routes.root}cart`);
        } catch (error) {
          this.error.hidden = false;
          this.submitting = false;
          if (submitButton) submitButton.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
